import React, { useState, lazy, Suspense } from 'react'
import { dataTrackingValues } from '@leshen/ui'

import AvailabilitySubmissionMessage from './AvailabilitySubmissionMessage'
import defaultAvailabilitySubmit from './availabilitySubmit'
import * as Styled from './availability.styles'
import { useUser } from '../../../context/UserProvider'
import { useMapi } from '../../../context/MapiProvider'

const Form = lazy(() =>
  import('@leshen/ui/dist/esm/packages/ui/src/components/Form')
)

const Availability = ({
  label = null,
  buttonText = 'Find',
  buttonColor = 'primary',
  buttonOutlined = false,
  buttonGradient = false,
  handleSubmit = defaultAvailabilitySubmit,
  placeholderText = '',
  setShowModal = null,
  formVisibility = 'both',
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const { setZipLocation, isLoading, setUserData } = useUser()
  const { FORM } = dataTrackingValues
  const { requestId } = useMapi()
  const formVisibilityValue =
    typeof formVisibility === 'string' ? formVisibility.toLowerCase() : ''
  const zipField = [
    {
      label,
      name: 'zip_postal',
      value: '',
      required: true,
      type: 'text',
      placeholderText,
    },
  ]

  return (
    <>
      <Suspense fallback="loading...">
        <Styled.ZipFormWrapper formVisibility={formVisibility}>
          <Form
            inlineButton
            submitButtonGradient={buttonGradient}
            formSource="static"
            fields={zipField}
            submitButtonText={buttonText}
            submitButtonColor={buttonColor}
            submitButtonOutlined={buttonOutlined}
            formVisibility={formVisibilityValue}
            onSubmit={({ values }) => {
              if (setShowModal) {
                setShowModal(false)
              }
              setZipLocation(values.zip_postal).then((location) => {
                handleSubmit({
                  values,
                  setIsSubmitted,
                  setUserData,
                  location,
                })
              })
              FORM.AVAILABILITY.handleClick(
                values.zip_postal,
                buttonText,
                requestId
              )
            }}
          />
        </Styled.ZipFormWrapper>
        {isSubmitted && !isLoading && <AvailabilitySubmissionMessage />}
      </Suspense>
    </>
  )
}

export default Availability
